import { render, staticRenderFns } from "./ListaAnte.vue?vue&type=template&id=6be15ac6&"
import script from "./ListaAnte.vue?vue&type=script&lang=js&"
export * from "./ListaAnte.vue?vue&type=script&lang=js&"
import style0 from "./ListaAnte.vue?vue&type=style&index=0&id=6be15ac6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports